import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  computed,
  onMounted,
  onUnmounted,
  withDefaults,
} from 'vue';
import UserInfo from './components/RoomHeader/UserInfo';
import RoomHomeControl from './components/RoomHome/RoomControl';
import LanguageIcon from './components/common/Language.vue';
import SwitchTheme from './components/common/SwitchTheme.vue';
import { EventType, roomService } from './services/index';
import ScheduleRoomList from './components/ScheduleConference/ScheduleRoomList.vue';
import Logo from './components/common/Logo.vue';
import TUIMessageBox from './components/common/base/MessageBox/index';
import TUIMessage from './components/common/base/Message/index';
import { MESSAGE_DURATION } from './constants/message';
import { isMobile } from './utils/environment';
import InvitationNotification from './components/RoomInvite/InvitationNotification.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'preConference',
  props: {
    userInfo: { default: () => ({
      userId: '',
      userName: '',
      avatarUrl: '',
    }) },
    showEditNameInPc: { type: Boolean, default: false },
    roomId: { default: '' },
    enableScheduledConference: { type: Boolean, default: true },
    isShowLogo: { type: Boolean, default: true }
  },
  emits: [
  'on-create-room',
  'on-enter-room',
  'on-update-user-name',
  'on-logout',
],
  setup(__props: any, { emit: emits }) {

const props = __props as { userInfo: {
      userId: string;
      userName: string;
      avatarUrl: string;
    }, showEditNameInPc: boolean, roomId: string, enableScheduledConference: boolean, isShowLogo: boolean };

const roomControlRef = ref();




const tuiRoomThemeClass = computed(
  () => `tui-theme-${roomService.basicStore.defaultTheme}`
);

async function handleCreateRoom(roomOption: Record<string, any>) {
  emits('on-create-room', roomOption);
}

async function handleEnterRoom(roomOption: Record<string, any>) {
  emits('on-enter-room', roomOption);
}

function handleUpdateUserName(userName: string) {
  emits('on-update-user-name', userName);
}

async function handleLogOut() {
  emits('on-logout');
}

const showMessageBox = (data: {
  code?: number;
  message: string;
  title: string;
  duration?: number;
  cancelButtonText: string;
  confirmButtonText: string;
  callback?: () => void;
}) => {
  const {
    message,
    title = roomService.t('Note'),
    duration,
    cancelButtonText,
    confirmButtonText = roomService.t('Sure'),
    callback = () => {},
  } = data;
  TUIMessageBox({
    title,
    message,
    duration,
    cancelButtonText,
    confirmButtonText,
    callback,
  });
};
const showMessage = (data: {
  type: 'warning' | 'success' | 'error' | 'info';
  message: string;
  duration: MESSAGE_DURATION;
}) => {
  const { type, message, duration } = data;
  TUIMessage({
    type,
    message,
    duration,
  });
};

onMounted(() => {
  roomService.on(EventType.ROOM_NOTICE_MESSAGE, showMessage);
  roomService.on(EventType.ROOM_NOTICE_MESSAGE_BOX, showMessageBox);
});
onUnmounted(() => {
  roomService.off(EventType.ROOM_NOTICE_MESSAGE, showMessage);
  roomService.off(EventType.ROOM_NOTICE_MESSAGE_BOX, showMessageBox);
});

return { __sfc: true,roomControlRef, props, emits, tuiRoomThemeClass, handleCreateRoom, handleEnterRoom, handleUpdateUserName, handleLogOut, showMessageBox, showMessage, UserInfo, RoomHomeControl, LanguageIcon, SwitchTheme, ScheduleRoomList, Logo, isMobile, InvitationNotification }
}

})